import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './RacingThemeBookBookingPanel.module.css';

const ShieldIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

/**
 * Book listing CTA column — date / time / guests + request to book.
 */
const RacingThemeBookBookingPanel = props => {
  const {
    className,
    title,
    price,
    priceSuffix,
    dateOptions,
    timeOptions,
    guestOptions,
    primaryCta,
    trustText,
    onRequestBook,
  } = props;

  const [date, setDate] = useState(dateOptions[0] || '');
  const [time, setTime] = useState(timeOptions[0] || '');
  const [guests, setGuests] = useState(guestOptions[0] || '');

  return (
    <aside className={classNames(css.root, className)}>
      <h2 className={css.title}>{title}</h2>
      <p className={css.price}>
        {price}
        {priceSuffix ? <span className={css.priceSuffix}>{priceSuffix}</span> : null}
      </p>

      <label className={css.field}>
        <span className={css.fieldLabel}>Pick a Date</span>
        <select className={css.select} value={date} onChange={event => setDate(event.target.value)}>
          {dateOptions.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>

      <label className={css.field}>
        <span className={css.fieldLabel}>Start Time</span>
        <select className={css.select} value={time} onChange={event => setTime(event.target.value)}>
          {timeOptions.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>

      <label className={css.field}>
        <span className={css.fieldLabel}>Number of Guests</span>
        <select
          className={css.select}
          value={guests}
          onChange={event => setGuests(event.target.value)}
        >
          {guestOptions.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>

      <button className={css.primaryBtn} type="button" onClick={onRequestBook}>
        {primaryCta}
      </button>

      <p className={css.trust}>
        <ShieldIcon />
        {trustText}
      </p>
    </aside>
  );
};

RacingThemeBookBookingPanel.defaultProps = {
  className: null,
  priceSuffix: null,
  dateOptions: [],
  timeOptions: [],
  guestOptions: [],
  primaryCta: 'Request to Book',
  trustText: "You won't be charged yet",
  onRequestBook: () => {},
};

RacingThemeBookBookingPanel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  priceSuffix: PropTypes.string,
  dateOptions: PropTypes.arrayOf(PropTypes.string),
  timeOptions: PropTypes.arrayOf(PropTypes.string),
  guestOptions: PropTypes.arrayOf(PropTypes.string),
  primaryCta: PropTypes.string,
  trustText: PropTypes.string,
  onRequestBook: PropTypes.func,
};

export default RacingThemeBookBookingPanel;
